module.exports = __webpack_public_path__ + "img/geekbang.4c2e66c4.png";